import { endOfDay, isPast, isSameDay } from 'date-fns';
export const isDateStrikeThrough = (date, strikeThroughDates) => strikeThroughDates?.some((strikeThroughDate) => isSameDay(new Date(strikeThroughDate), date));
export const hasDotOnDate = (date, dotOnDates) => {
    if (!dotOnDates || dotOnDates.length === 0)
        return false;
    return dotOnDates.some((dotOnDate) => isSameDay(new Date(dotOnDate), date));
};
export function hasDatePassed(date) {
    // use isPast function to check if the date is in the past
    const endingOfDay = endOfDay(date);
    return isPast(endingOfDay);
}
export const firstLetterUpperCase = (string) => `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`;
export const getDateCellVariant = (isSelectedDay, isCurrentDay, isOutSideMonth, isBetweenRange, isStartDate, isEndDate, hasEndDate) => {
    if (isStartDate) {
        if (!hasEndDate) {
            return 'selectedDay';
        }
        return 'startDateRange';
    }
    if (isEndDate) {
        return 'endDateRange';
    }
    if (isSelectedDay) {
        return 'selectedDay';
    }
    if (isBetweenRange) {
        return 'isSelectedRangeDay';
    }
    if (isCurrentDay) {
        return 'currentDay';
    }
    if (isOutSideMonth) {
        return 'outSideMonth';
    }
    return 'normal';
};
export const getWeekCellVariant = (isSelectedWeek, isCurrentDay) => {
    if (isSelectedWeek) {
        return 'selectedDay';
    }
    if (isCurrentDay) {
        return 'currentDay';
    }
    return 'normal';
};
//# sourceMappingURL=datepicker.helper.js.map